import axios from "axios";
import { TokenManager } from "../utils/tokenManager";
import { BASE_URL } from "../config/apiconfig";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Attach JWT token automatically
api.interceptors.request.use(
  (config) => {
    const token = TokenManager.getToken();

    console.log("=== Axios Request Interceptor ===");
    console.log("Request URL:", config.url);
    console.log("Request method:", config.method);
    console.log("Token from TokenManager:", token ? "Token found" : "No token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log("Authorization header set:", config.headers.Authorization);
      console.log("Token being sent (first 20 chars):", token.substring(0, 20) + "...");
    } else {
      console.log("WARNING: No token found - Authorization header will NOT be set");
    }

    // Add custom headers to avoid preflight for simple GET requests
    if (config.method === 'get' && !config.params) {
      config.params = {};
    }

    // For blob responses (file downloads), don't set Accept: application/json
    if (config.responseType === 'blob' || config.responseType === 'arraybuffer') {
      delete config.headers.Accept;
      delete config.headers['Accept'];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors
api.interceptors.response.use(
  (response) => {
    // Log blob responses for debugging
    if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
      console.log("=== Blob Response ===");
      console.log("URL:", response.config.url);
      console.log("Status:", response.status);
      console.log("Headers:", response.headers);
      console.log("Data type:", typeof response.data);
      console.log("Data constructor:", response.data?.constructor?.name);
      console.log("Data size:", response.data?.size);
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
